import { DestinationUrlInput } from 'features/campaign/campaign.types';

export const DestinationUrlInputDisplay: Record<DestinationUrlInput, string> = {
  [DestinationUrlInput.ASIN]: 'ASIN',
  [DestinationUrlInput.BROWSE_NODE]: 'Browse node',
  [DestinationUrlInput.LINK]: 'Manual',
  [DestinationUrlInput.DEALS]: 'Deals',
};

// Original link type options without 'Deals' option
const initialLinkTypeOptions = [
  DestinationUrlInput.ASIN,
  DestinationUrlInput.BROWSE_NODE,
  DestinationUrlInput.LINK,
];

// Link type options including 'Deals' option (currently behind Feature Flag)
export const newLinkTypeOptions = [
  ...initialLinkTypeOptions,
  DestinationUrlInput.DEALS,
];

// Placeholder values for Link types
export const placeholderMapping = {
  [DestinationUrlInput.BROWSE_NODE]: '6669703011',
  [DestinationUrlInput.ASIN]: 'B00TSUGXKE',
  [DestinationUrlInput.LINK]: 'e.g. /kindle, /gp/aw/s?hidden-keywords=echo',
  [DestinationUrlInput.DEALS]: 'c7fe83a2, e7fce6a4',
};
